module.exports = __webpack_public_path__ + "images/application/illustrations/server-097bf3c0.svg";